import { RiLeafLine } from "@remixicon/react";
import { Button } from "@earth-note/ui";
import { SIGNUP_URL } from "../utils/constants";
import type { AddinConfigDisabled } from "../types";

interface NonCustomerProps {
  config: AddinConfigDisabled;
}

export function NonCustomer({ config }: NonCustomerProps) {
  const signupUrl = config.signupUrl ?? SIGNUP_URL;

  return (
    <div className="flex h-full flex-col p-6">
      <div className="mb-6 flex justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-yellow-100">
          <RiLeafLine className="h-8 w-8 text-yellow-600" />
        </div>
      </div>

      <div className="mb-6 text-center">
        <h2 className="text-title-h6 mb-2 font-semibold text-text-strong-950">
          Earth Note Not Active
        </h2>
        <p className="text-paragraph-sm text-text-sub-600">{config.message}</p>
      </div>

      <div className="mt-auto">
        <a href={signupUrl} target="_blank" rel="noopener noreferrer">
          <Button.Root className="w-full">Learn More About Earth Note</Button.Root>
        </a>
      </div>

      <p className="mt-4 text-center text-paragraph-xs text-text-soft-400">
        Add climate awareness to your emails
      </p>
    </div>
  );
}
